import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=453bb014"
import script from "./EventListItem.vue?vue&type=script&lang=js"
export * from "./EventListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports